// extracted by mini-css-extract-plugin
export default {"root":"MobilePaginationWithJump_root__4Q-4G","navButton":"MobilePaginationWithJump_navButton__melqK","pageInfo":"MobilePaginationWithJump_pageInfo__7f1ir"};